import {AccountMenu} from './account-menu';

export * from './account-menu-props';

export default AccountMenu;
